/**
 * 指定された配列を昇順でソートする。
 *
 * @param source 元データ
 * @param valuePickers 比較対象とする値を取り出す関数 複数指定された場合は値が等しかった場合に2番目・3番目にフォールバックする(thenby)
 * @returns ソートした配列
 */
export const orderBy = <T>(source: readonly T[], ...valuePickers: ((item: T) => any)[]) => {
    const copied = [...source];

    copied.sort((a, b) => compare(a, b, valuePickers));

    return copied;
};

const compare = <T>(a: T, b: T, pickers: ((item: T) => number | string | bigint)[]) => {
    for (const p of pickers) {
        const valA = p(a);
        const valB = p(b);

        if (valA < valB) {
            return -1;
        } else if (valA > valB) {
            return 1;
        }
    }

    return 0;
};

/**
 * 指定された配列を降順でソートする。
 *
 * @param source 元データ
 * @param valuePickers 比較対象とする値を取り出す関数 複数指定された場合は値が等しかった場合に2番目・3番目にフォールバックする(thenby)
 * @returns ソートした配列
 */
export const orderByDescending = <T>(source: readonly T[], ...valuePickers: ((item: T) => any)[]) => {
    const copied = [...source];

    copied.sort((a, b) => -compare(a, b, valuePickers));

    return copied;
};
